import { FC } from 'react';

export const AppFooter: FC = () => (
  <footer style={{ textAlign: 'center', height: '50px' }}>
    © Aryballe {new Date().getFullYear()} — ver. <b>{process.env.REACT_APP_VER || ''}</b> {process.env.REACT_APP_ENV && `[${process.env.REACT_APP_ENV.toUpperCase()}]`}
  </footer>
);
